import React from 'react'
import LeftNavigation from '@src/routes/Configurators/components/LeftNavigation'
import { SidebarItem } from '@src/routes/Configurators/components/LeftNavigation/LeftNavigation'

interface LeftSideBarProps {
  sidebarItems: SidebarItem[]
}

const LeftSideBar: React.FC<LeftSideBarProps> = ({ sidebarItems }) => {
  return (
    <>
      <LeftNavigation sidebarItems={sidebarItems} />
    </>
  )
}

export default LeftSideBar
